export enum FeatureFlag {
  useClarityRecordingTool = 'use_clarity_recording_tool',
  showRoomDuration = 'show_room_duration',
  ashleyExpertTest = 'ashley_expert_test',
  useSentryPerformance = 'use_sentry_performance',
  showPromoCodeOnPaywall = 'show_promo_code_on_paywall',
  useLiveRoomDrawer = 'use-live-room-drawer',
  myPlanRoomsUseAi = 'my_plan_rooms_use_ai',
  showQuizOnboarding = 'show_quiz_onboarding',
  showOnboardingV4 = 'show_onboarding_v4',
  logLogzIo = 'log-logz-io',
  showTwilioLowNetworkQualityErrorToast = 'show_twilio_low_network_quality_error_toast',
  showTwilioLowNetworkQualityErrorToastV2 = 'show_twilio_low_network_quality_error_toast_v2',
  useWebsockets = 'use-websockets',
  showAllProductsScreen = 'show_all_products_screen',
  forceTwilioAudioProvider = 'force_twilio_audio_provider',
  percentageChanceToCreateRoomWithoutTwilio = 'percentage_chance_to_create_room_without_twilio',
  showProfileV2 = 'show_profile-v2',
  useDesignV2 = 'use-design-v2',
  hideRoomsForGrantedUsers = 'hide_rooms_for_granted_users',
  showFirstPremiumRoomIndication = 'show_first_premium_room_indication',
  showSupportGroups = 'show_support_groups',
  requirePaymentForAllFeatures = 'require_payment_for_all_features',
  showPersonalPricingPlan = 'show_personal_pricing_plan',
  specificSegmentExperience = 'specific_segment_experience',
  prioritiseSupportGroups = 'prioritise_support_groups',
  postOnboardingScheduler = 'post_onboarding_scheduler',
  useListeningMode = 'use_listening_mode',
  useLiveRoomCardDesignV2 = 'use_live_room_card_design_v2',
  usePricesFromStores = 'use_prices_from_stores',
  showIntercomHelpCenter = 'show_intercom_help_center',
  groupSessionAgenda = 'group_session_agenda',
  groupSessionRecapReminder = 'group_session_recap_reminder',
  useRoomDetailsV2 = 'use_room_details_v2',
  mobilePaywallV2 = 'mobile_paywall_v2',
  webPaywallV2 = 'web_paywall_v2',
  analyticsIdentifyLeads = 'analytics_identify_leads',
  showTheProgram = 'show_the_program',
  showWebPricingTest = 'show_web_pricing_test',
  showFirstTimeSurvey = 'show_first_time_survey',
  useWebOnboarding = 'use_web_onboarding',
  useWebviewOnboarding = 'use_webview_onboarding',
  preloadWebviewOnboarding = 'preload_webview_onboarding',
  showLobbyAsDefaultTab = 'show_lobby_as_default_tab',
  useWebPricingTestWeekly = 'use_web_pricing_test_weekly',
}
